import React, { useEffect, useState } from 'react';

export const ClockHeaderControls = ({ clock, onApply, displayLabel }) => {
  const { time, label, isManual, setManualTime, resetToAuto } = clock;
  const [modalOpen, setModalOpen] = useState(false);
  const [pickerValue, setPickerValue] = useState('');
  const timeLabel = displayLabel || label;

  useEffect(() => {
    setPickerValue(toLocalInputValue(time));
  }, [time]);

  const applyManualTime = () => {
    const date = pickerValue ? new Date(pickerValue) : null;
    if (date && !Number.isNaN(date.getTime())) {
      setManualTime(date);
      if (typeof onApply === 'function') {
        onApply(date);
      }
    }
    setModalOpen(false);
  };

  const applyQuickOffset = (offsetSeconds) => {
    const base = pickerValue ? new Date(pickerValue) : new Date(time);
    const next = new Date(base.getTime() + offsetSeconds * 1000);
    setPickerValue(toLocalInputValue(next));
  };

  return (
    <>
      <div className="time-display">
        <span id="timeLabel" className="current-time">{timeLabel}</span>
        <button id="modifyTimeBtn" className="time-edit-btn" title="Editar hora" onClick={() => setModalOpen(true)}>
          <i data-lucide="edit" />
        </button>
      </div>

      {modalOpen && (
        <div id="datetimeModal" className="modal" style={{ display: 'block' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h3>Modificar Fecha y Hora</h3>
              <button className="modal-close" onClick={() => setModalOpen(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="datetime-picker" className="form-label">Seleccionar fecha y hora</label>
                <input
                  type="datetime-local"
                  id="datetime-picker"
                  className="form-input"
                  value={pickerValue}
                  onChange={(event) => setPickerValue(event.target.value)}
                />
              </div>
              <div className="quick-time-options">
                <button type="button" className="quick-time-btn" onClick={() => applyQuickOffset(0)}>
                  Ahora
                </button>
                <button type="button" className="quick-time-btn" onClick={() => applyQuickOffset(3600)}>
                  +1 Hora
                </button>
                <button type="button" className="quick-time-btn" onClick={() => applyQuickOffset(-3600)}>
                  -1 Hora
                </button>
              </div>
            </div>
            <div className="modal-footer">
              {isManual && (
                <button type="button" className="btn-secondary" onClick={resetToAuto}>
                  Volver a automático
                </button>
              )}
              <button type="button" className="btn-secondary" onClick={() => setModalOpen(false)}>
                Cancelar
              </button>
              <button type="button" className="btn-primary" onClick={applyManualTime}>
                Aplicar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const HoursAdjuster = ({ value = null, onApply, onReset, maxHours = 12 }) => {
  const [hoursValue, setHoursValue] = useState(value ? String(value) : '');

  useEffect(() => {
    setHoursValue(value ? String(value) : '');
  }, [value]);

  const applyOverride = () => {
    const parsed = parseInt(hoursValue, 10);
    if (Number.isNaN(parsed) || parsed < 1 || parsed > maxHours) {
      alert(`Ingrese un valor entre 1 y ${maxHours} horas`);
      return;
    }
    if (typeof onApply === 'function') {
      onApply(parsed);
    }
  };

  const resetOverride = () => {
    setHoursValue('');
    if (typeof onReset === 'function') {
      onReset();
    }
  };

  return (
    <div className="new-hours-control">
      <label htmlFor="hours-input" className="new-hours-label">Ajustar Horas</label>
      <div className="input-wrapper input-wrapper--icon-right">
        <i data-lucide="clock" className="input-icon" />
        <input
          type="number"
          id="hours-input"
          min="1"
          max={String(maxHours)}
          className="new-hours-input"
          placeholder={`1-${maxHours} horas`}
          value={hoursValue}
          onChange={(event) => setHoursValue(event.target.value)}
        />
      </div>
      <div className="button-group">
        <button id="apply-hours-btn" className="new-action-btn primary" onClick={applyOverride}>
          Aplicar
        </button>
        <button
          id="reset-hours-btn"
          className="new-action-btn secondary"
          title="Restablecer a tiempo de vida"
          onClick={resetOverride}
        >
          <i data-lucide="rotate-ccw" />
        </button>
      </div>
    </div>
  );
};

const toLocalInputValue = (date) => {
  if (!(date instanceof Date)) {
    return '';
  }
  const tzoffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - tzoffset).toISOString().slice(0, 16);
};
